import type { MinigameDefinition } from '@core/types';
import { TriviaConfig } from '@modules/trivia/config';
import { TriviaScene } from '@modules/trivia/TriviaScene';

/** Definicion publica del modulo de trivia para registrarlo en el catalogo. */
export const triviaMinigame: MinigameDefinition = {
  key: TriviaConfig.key,
  title: TriviaConfig.title,
  description: TriviaConfig.description,
  icon: TriviaConfig.icon,
  color: TriviaConfig.color,
  scene: TriviaScene,
};
